import moment from 'moment';
import {filter} from 'lodash';

export class Helpers {


    currencySymbolMapping: CurrencySymbolMapping[] = [
        {
            code: 'gbp',
            symbol: '£'
        },
        {
            code: 'eur',
            symbol: '€'
        },
        {
            code: 'usd',
            symbol: '$'
        },
        {
            code: 'cad',
            symbol: 'CAD$'
        },
        {
            code: 'aud',
            symbol: 'A$'
        }
    ];

    resolveCurrencySymbol(currencyCode: string): string {
        currencyCode = currencyCode.toLowerCase();
        let mappedObj = filter(this.currencySymbolMapping, [ 'code', currencyCode ]);

        if(mappedObj.length) {
            return mappedObj[0].symbol;
        }
        return currencyCode;
    }

    getUniqueKey(): string {
    	return this.uuid4();
    }

    uuid4(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
            function(c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
    }

    formatPrice(price: number): string {
        return '£' + (price / 100).toFixed(2);
    }

    formatWeight(grams: number): string {
        if (grams > 1000) {
            return (grams / 1000) + 'kg';
        } else {
            return grams + 'g';
        }
    }

    formatDate(date: string, dateFormat = 'Do MMMM YYYY'): string {
        return moment(date).format(dateFormat);
    }

};

export const helpers = new Helpers();
